import { render } from "./CustomerManagement.vue?vue&type=template&id=771c8a99&scoped=true"
import script from "./CustomerManagement.vue?vue&type=script&lang=js"
export * from "./CustomerManagement.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=771c8a99&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771c8a99"]])

export default __exports__